(() => {
  const order = ['EU', 'UK', 'US', 'CA'];
  const labels = { EU: 'EU', UK: 'UK', US: 'US', CA: 'CA' };

  const formatRegions = (value) => {
    let regions = value;
    if (typeof regions === 'string') {
      try { regions = JSON.parse(regions); } catch { regions = regions.split(/[\s,|]+/); }
    }
    if (!Array.isArray(regions)) return [];
    return order.filter((code) => regions.some((region) => String(region).toUpperCase().trim() === code));
  };

  const regionText = (regions, translations) => {
    const names = regions.map((code) => labels[code]);
    const key = ['single', 'pair', 'triple', 'four'][regions.length - 1];
    if (names.length === 1) return translations[key].replaceAll('__REGION__', names[0]);
    return names.reduce(
      (text, name, index) => text.replaceAll(`__REGION_${index + 1}__`, name),
      translations[key]
    );
  };

  const init = (root) => {
    const data = root.parentElement?.querySelector('[data-overseas-variant-regions]');
    const translationData = root.parentElement?.querySelector('[data-overseas-translations]');
    if (!data || !translationData) return;
    const source = root.parentElement?.querySelector('[data-overseas-translation-source]');
    if (source) {
      root.querySelector('[data-overseas-in-stock]').textContent = source.querySelector('[data-overseas-t="in_stock"]')?.textContent.trim() || 'In stock';
      root.querySelector('[data-overseas-estimated-delivery]').textContent = source.querySelector('[data-overseas-t="estimated_delivery"]')?.textContent.trim() || 'Estimated delivery: 3–10 working days';
    }
    let variantRegions;
    let translations;
    try {
      variantRegions = JSON.parse(data.textContent);
      translations = JSON.parse(translationData.textContent);
    } catch { return; }
    const render = (variantId) => {
      const regions = formatRegions(variantRegions[String(variantId)] || []);
      const line = root.querySelector('[data-overseas-regions]');
      if (!regions.length) { root.hidden = true; return; }
      if (source) {
        const key = ['single_region', 'two_regions', 'three_regions', 'four_regions'][regions.length - 1];
        const template = source.querySelector(`[data-overseas-t="${key}"]`)?.textContent.trim();
        if (template) {
          line.textContent = regions.reduce((text, code, index) => text.replaceAll(regions.length === 1 ? '__REGION__' : `__REGION_${index + 1}__`, code), template);
        } else line.textContent = regionText(regions, translations);
      } else line.textContent = regionText(regions, translations);
      root.hidden = false;
    };
    render(root.closest('main')?.querySelector('[name="id"]')?.value || Object.keys(variantRegions)[0]);
    document.addEventListener('change', (event) => {
      if (event.target.matches('[name="id"]')) render(event.target.value);
    });
    document.addEventListener('variant:changed', (event) => {
      const id = event.detail?.variant?.id || event.detail?.variantId;
      if (id) render(id);
    });
  };
  document.querySelectorAll('[data-overseas-fast-delivery]').forEach(init);
})();
